import Vue from 'vue';

import enterNumDirective from './enterNum';

const directives = [
  enterNumDirective
]

directives.forEach(directive => {
  Vue.directive(directive.name, directive);
});



// WEBPACK FOOTER //
// ./src/directives/index.js